import React, { Component } from 'react';
import './logoSection.css';
import DesignSection from './designSection';
import SectionBanner from './sectionBanner';
import SectionPageHeader from './sectionPageHeader';

export default class LetterheadSection extends Component {
  render() {
    return (
      <div className="sectionContainer full-width">
        <SectionBanner image="/images/background-lines-gradient-purple.webp" title="Letterheads" />
        <SectionPageHeader description="Branded letterheads ensure all formal written communications reflect our identity consistently and professionally. Use the approved templates for any client-facing or official documents. Click 'View' on the letterhead of your choosing and select it from the Google Docs Template list. This will make a copy of the doc for your own use." />
        <DesignSection>          
          <div className="small-bottom-margin">
            <div className="section-padding no-top-padding">
              <div className="">
                <div className="row">
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/yipit-letterhead-cover.png'} className="full-width small-bottom-margin" alt="Example of the YipitData letterhead" />
                    <p className="subheading tiny-bottom-margin">{'A full cover letter with editable subtitles and date, plus letterhead.'} </p>
                    <a className="downloadText" href="https://docs.google.com/document/u/0/?tgif=d&ftv=1" target="_blank">
                      View
                      <span className="material-symbols-rounded">open_in_new</span>
                    </a>
                  </div>
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/yipit-letterhead-blankcover.png'} className="full-width small-bottom-margin" alt="Example of the YipitData letterhead" />
                    <p className="subheading tiny-bottom-margin">{'Just a blank cover letter.'} </p>
                    <a className="downloadText" href="https://docs.google.com/document/u/0/?tgif=d&ftv=1" target="_blank">
                      View
                      <span className="material-symbols-rounded">open_in_new</span>
                    </a>
                  </div>
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/yipit-letterhead-nocover.png'} className="full-width small-bottom-margin" alt="Example of the YipitData letterhead" />
                    <p className="subheading tiny-bottom-margin">{'This letterhead has no cover page attached.'} </p>
                    <a className="downloadText" href="https://docs.google.com/document/u/0/?tgif=d&ftv=1" target="_blank">
                      View
                      <span className="material-symbols-rounded">open_in_new</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DesignSection>
      </div>
    );
  }
}
